import { InputSize } from '@/models/form/form';

export const INPUT_HEIGHT = {
  [InputSize.LARGE]: '48px',
  [InputSize.MEDIUM]: '40px',
  [InputSize.SMALL]: '32px',
};
